import { SchedulerSidebarCrewChangeScope } from '@contexts/scheduler/sidebar/types';
import { CurrentSchedule, RelatedMultischedule } from '@services/schedules/internal/types';
import { shortDate, shortDayDate } from '@utils/i18n';
import { parseISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { checkScheduleDisabled } from '../days/helpers';
import { ChangeScopeLabelParams } from './types';

export const getChangeScopeLabelParams = ({
  relatedMultischedules,
  currentSchedule,
  zone,
}: {
  relatedMultischedules: Record<string, RelatedMultischedule[]>;
  currentSchedule: CurrentSchedule;
  zone: string;
}): ChangeScopeLabelParams | null => {
  if (!currentSchedule.startsAt) return null;

  const day = toZonedTime(parseISO(currentSchedule.startsAt), zone);
  const schedules = Object.values(relatedMultischedules).flat();
  const otherMatchingDays = (crewChangeScope: SchedulerSidebarCrewChangeScope) =>
    schedules.filter(
      (schedule) =>
        schedule.id !== currentSchedule.id &&
        !checkScheduleDisabled({ schedule, currentSchedule, crewChangeScope, zone }),
    ).length;

  return {
    currentOnly: { date: shortDayDate(day) },
    currentAndFuture: { date: shortDate(day), count: otherMatchingDays('currentAndFuture') },
    all: { count: otherMatchingDays('all') + 1 },
  };
};
